import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import SidebarPage from '../sidebar'
import DashboardCards from './socialiconcard'

export default function Socialdetailspost() {
  const navigate = useNavigate()
  const [isLargeScreen, setIsLargeScreen] = useState(() => window.innerWidth >= 1000)
  const [username, setUsername] = useState('')

  // ✅ Redirect to login if token is missing
  useEffect(() => {
    const token = sessionStorage.getItem('token')
    if (!token) {
      navigate('/adminlogin')
    }
  }, [navigate])

  // Handle screen resize for responsive layout
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1000)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Get username from localStorage
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedUsername = localStorage.getItem('username')
      setUsername(storedUsername || '')
    }
  }, [])

  // Styles for large screen (≥1000px)
  const largeContainerStyle = {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#fff',
  }

  const largeSidebarStyle = {
    width: '15rem',
    backgroundColor: '#f8f9fa',
    borderRight: '1px solid #ddd',
    padding: '1rem',
    boxSizing: 'border-box',
  }

  const largeMainStyle = {
    flexGrow: 1,
    padding: '5rem',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  }

  // Styles for small screen (<1000px)
  const smallContainerStyle = {
    display: 'block',
    minHeight: '100vh',
    backgroundColor: '#fff',
  }

  const smallSidebarStyle = {
    width: '100%',
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #ddd',
    padding: '1rem',
    boxSizing: 'border-box',
  }

  const smallMainStyle = {
    padding: '2rem',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  }

  return (
    <div style={isLargeScreen ? largeContainerStyle : smallContainerStyle}>
      <aside style={isLargeScreen ? largeSidebarStyle : smallSidebarStyle}>
        <SidebarPage />
        {username && (
          <p style={{ marginTop: '1rem', fontWeight: 'bold' }}>
            Welcome, {username}
          </p>
        )}
      </aside>

      <main style={isLargeScreen ? largeMainStyle : smallMainStyle}>
        <DashboardCards />
      </main>
    </div>
  )
}
